import global_define from '../library/global/define'

var api_url_domain = global_define.api_url_domain

function api_append(url_path) {
    return api_url_domain + url_path
}

export default {
    user: {
        login: api_append("/api/user/login"),
        logout: api_append("/user/logout"),
        bind: api_append("/api/user/bind"),
        unbind: api_append("/api/user/unbind"),
        register: api_append("/api/user/register"),
        reset_password: api_append("/api/user/reset_password"),
        forget_password: api_append("/api/user/forget_password"),
        userinfo: api_append("/api/user/user/info"),
        update: api_append("/api/user/user/update"),
    },
    order: {
        create: api_append("/api/order/create"),
        pre_create: api_append("/api/order/pre/create"),
        delete: api_append("/api/order/delete"),
        list: api_append("/api/order/list"),
        detail: api_append("/api/order/detail"),
        report_order_detail: api_append("/api/report/report/order/detail"),
        fetch_report_edit: api_append("/api/report/edit/fetch"),
        update: api_append("/api/order/update"),
        commit: api_append("/api/order/commit"),
        asign_inspector: api_append("/api/order/asign_inspector"),
        menu_price_list: api_append("/api/detect/detect_menu_price_list"),
        customer_detail: api_append("/api/order/customer/detail"),
        auto_detail: api_append("/api/order/auto/detail"),
        inspector_detail: api_append("/api/order/inspector/detail"),
        menu_detail: api_append("/api/order/menu/detail"),
        group_object_detail: api_append("/api/order/detect/group/object/detail"),
        export_order: api_append("/api/report/export/order/detail"),
        report_detail: api_append("/api/order/report/detail"),
    },
    detect_object: {
        update_detect_group_object: api_append("/api/detect/update_detect_group_object"),
    },
    search: {
        search: api_append("/api/search"),
    },
    wechat: {
        redirect_feedback: global_define.access_control_allow_origin + "/wechat/redirect/feedback",
        redirect_bind: global_define.access_control_allow_origin + "/wechat/redirect/bind",
        redirect_unbind: global_define.access_control_allow_origin + "/wechat/redirect/unbind",
        mp_redirect_feedback: global_define.access_control_allow_origin + "/wechat/mp/redirect/feedback",
        mp_redirect_bind: global_define.access_control_allow_origin + "/wechat/mp/redirect/bind",
        mp_redirect_unbind: global_define.access_control_allow_origin + "/wechat/mp/redirect/unbind",
        js_sdk_params: api_append("/wechat/jssdk/signature"),
    },
    company: {
        index: api_append("/api/company/index")
    },
    static: {
        qrcode: api_append("/tools/qrcode"),
        company_searl: api_append("/static/company/company_searl.png"),
    },
    inspector: {
        list: api_append("/api/inspector/list")
    }
}